var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34 3.82c-1.108.055-2.033 1.508-.952 2.534l8.54 8.541-8.567 8.566a1.451 1.451 0 102.053 2.053l8.566-8.566 8.566 8.566a1.452 1.452 0 102.053-2.053l-8.566-8.566 8.54-8.541c1.443-1.368-.684-3.495-2.052-2.053l-8.54 8.541-8.54-8.54c-.342-.361-.732-.5-1.102-.481z",
    fill: "#ffffff"
  })));
};

export default SvgCancel;